import React from 'react';

import cn from 'classnames';

import { Drawer } from '@element/index';
import useClient from '@lib/hooks/useClient';

import Content from './Content';

import styles from './index.module.css';

export default function SearchDrawer (props) {
  const { visible, setVisible } = props;
  const isPc = useClient();

  return (
    <>
      { visible && <Drawer
        visible={visible}
        onClose={() => setVisible(false)}
        closable={false}
        placement={isPc ? 'left' : 'bottom'}
        width={494}
        className={cn(styles.searchDrawer, {
          [styles.pcDrawer]: isPc
        })}
        content={<Content
          setVisible={setVisible}
        />}
      />}
    </>
  )
}
